import { ValidationProvider, ValidationObserver } from "vee-validate";
import NotificationMenu from "../../Notification/NotificationMenu.vue";
import DeleteConfirm from "@/components/Crud/Modals/Confirm";
import Swal from "sweetalert";
export default {
  name: "CrudForm",
  props: {
    parentUrlKey: {
      type: String,
      default: "",
    },
    parentStoreName: {
      type: String,
      default: "",
    },
    parentStoreUrl: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: "Section",
    },
    storeName: {
      type: String,
      default: "",
    },
    labelBack: {
      type: String,
      default: "Atras",
    },
    labelCancel: {
      type: String,
      default: "Cancelar",
    },
    labelSubmit: {
      type: String,
      default: "Guardar",
    },
    removeText: {
      type: String,
      default: "Eliminar",
    },
    submit: {
      type: Function,
      default: () => {
        //
      },
    },
    sendCode: {
      type: Function,
      default: () => {
        //
      },
    },
    status: {
      type: String,
      default: "",
    },
    canCancel: {
      type: Boolean,
      default: true,
    },
    canSubmit: {
      type: Boolean,
      default: true,
    },
    canCancelMessage: {
      type: Boolean,
      default: false,
    },
    urlBackSpot: {
      type: String,
      default: "",
    },
    urlSendNotification: {
      type: String,
      default: "",
    },
    breadcrumbs: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: "Section"
    },
    titleDeleted: {
      type: String,
      default: "Eliminar el registro",
    },
    descriptionDeleted: {
      type: String,
      default: "¿Quieres eliminar este registro?",
    },
    labelModalConfirm: {
      type: String,
      default: "",
    },
    labelModalCancel: {
      type: String,
      default: "",
    },
    canUpdateDelete: {
      type: Boolean,
      default: true,
    },
    canRefundCode: {
      type: Boolean,
      default: false,
    },
    nextLink: {
      type: String,
      default: "",
    },
  },
  data() {
    return { confirmDelete: false, }
  },
  created() {
    //
  },
  computed: {
    //
  },
  methods: {
    buildRootUrl() {
      if (this.parentUrlKey && this.parentStoreName) {
        return (
          "/admin/" +
          (this.parentStoreUrl || this.parentStoreName.toLowerCase()) +
          "/" +
          this.$route.params[this.parentUrlKey] +
          "/" +
          this.storeName.toLowerCase()
        );
      } else {
        return (
          "/admin/" + (this.parentStoreUrl || this.storeName.toLowerCase())
        );
      }
    },
    hideConfirmDelete() {
      this.confirmDelete = false;
    },
    async confirmDeleteItem() {
      const self = this;
      let route_delete = "/delete"
      self.$store
        .dispatch(this.storeName + route_delete, { id: self.$route.params.id })
        .then(() => {
          self.goBack();
        });
    },
    goBack() {
      this.$router.push(this.buildRootUrl());
    },
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    NotificationMenu,
    DeleteConfirm
  },
};
